import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CaretUp = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CaretUp' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='22 4 12 16 2 4' transform='matrix(1 0 0 -1 0 20)' />
  </StyledIcon>
);
